export default __webpack_public_path__ + "static/media/Group 3194@2x.40010958.png";